<template>
  <div class="lxm-cf-project-stat">
    <lxm-stat class="lxm-cf-project-stat__stat"></lxm-stat>
    <lxm-table :heads="tableHeads"
               :rows="tableRows"></lxm-table>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  .lxm-cf-project-stat__stat
    margin-top: spacing-big
</style>

<script>
  import LxmStat from '../../common/LxmStat.vue'
  import LxmTable from '../../common/LxmTable.vue'
  export default {
    components: {
      LxmStat,
      LxmTable
    },
    computed: {
      tableHeads () {
        return [
          '每日筹款情况',
          '人数',
          '金额'
        ]
      },
      tableRows () {
        return [
          [
            '今天',
            '30人',
            '￥123.45'
          ], [
            '11.23',
            '130人',
            '￥3,123.45'
          ], [
            '10.10',
            '130人',
            '￥3,123.45'
          ], [
            '09.23',
            '130人',
            '￥3,123.45'
          ]
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Stat.vue?11197309